const bOffice = {
    props: {
        item: {
            type: Object,
            default() {
                return null;
            },
        },
        tags: {
            type: Object,
            default() {
                return null;
            },
        },
        dictionary: {
            type: Object,
            default() {
                return {
                    address: "",
                    openingHours: "",
                    payments: "",
                    eAppointment: "",
                    navigation: "",
                    filters: "",
                };
            },
        },
        dismissible: {
            type: Boolean,
            default: false,
        },
        showAppointment: {
            type: Boolean,
            default: true,
        },
        userPosition: {
            type: Object,
            default() {
                return null;
            },
        },
    },
    data() {
        return {};
    },
    template: `

	<div v-if="item" class="b-office">		
		
		<div class="b-office__header">

			<div class="title">
				{{ item.title }}
			</div>
			<div class="close"
				v-if="dismissible === true">
				<button type="button"
					v-on:click="$emit('clear-selected-result')">
					<i class="icon-close"></i>
				</button>
			</div>
		</div>

		
		

		<div class="b-office__main">

			<ul>
				<li v-if="availTags.length">
					<div class="label">{{dictionary.filters}}</div>
					<div class="value">
						<div aria-hidden="true" class="b-office__filters">
							<i v-for="tag in availTags" class="b-office__filter" 
								data-bs-toggle="tooltip"
								data-bs-placement="top"
								:title="tag.text" 
								v-html="tag.icon"></i>
						</div>
					</div>
				</li>
				<li>
					<div class="label">{{dictionary.address}}</div>
					<div class="value">{{ item.address }}</div>
				</li>
				<li v-if="item.openingHours.length">
					<div class="label">
						{{dictionary.openingHours}}
					</div>
					<div class="value">
						<ul>
							<li v-for="(i, index) in item.openingHours">
								{{i}}
							</li>
						</ul>
					</div>
				</li>
				<li v-if="item.payments.length">
					<div class="label">
						{{dictionary.payments}}
					</div>
					<div class="value">
						<ul>
							<li v-for="(i, index) in item.payments">
								{{i}}
							</li>
						</ul>
					</div>
				</li>
			</ul>
		</div>

		<div class="b-office__footer">
			<ul>
				<li v-if="showAppointment && item.url !==''">
					<a :href="item.url" class="btn--blue">
						{{dictionary.eAppointment}}
					</a>
				</li>
				<li>
					<a :href="navigateToMap()" target="_blank" class="btn--blue">
						{{dictionary.navigation}}
					</a>
				</li>
			</ul>
		</div>
	</div>`,
    mounted() {
        var tooltipTriggerList = [].slice.call(
            this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
        );
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    },
    methods: {
        navigateToMap: function () {
            if (this.userPosition) {
                return `//www.google.com/maps/dir/?api=1&origin=${this.userPosition.lat},${this.userPosition.lng}&destination=${this.item.lat},${this.item.lng}`;
            }
            return `//www.google.com/maps/dir/?api=1&destination=${this.item.lat},${this.item.lng}`;
        },
    },
    computed: {
        availTags() {
            if (
                !this.item ||
                !this.tags ||
                !this.tags.length ||
                !this.item.tags.length
            )
                return [];

            return this.tags.filter((tag) => {
                if (this.item.tags.indexOf(tag.value) >= 0) return true;
            });
        },
    },
};
